import { CompAccordionCore } from '../core/accordion/comp'

export const CompAccordion = CompAccordionCore
